import Column from '@components/column'
import Banner from './banners'
import Doctors from './doctors'
import HealthProviders from './healthcareProviders'
import Tabs from '@commons/tabs'
const InstituteStaffsPage = () => {
  const tabs = [
    {
      title: 'Doctor List',
      key: 'doctors',
      Component: Doctors,
    },
    {
      title: 'Healthcare Provider',
      key: 'health-providers',
      Component: HealthProviders,
    },
  ]

  const handleSearchSubmit = () => {}
  return (
    <Column rowGap={20}>
      <Banner />
      <Tabs items={tabs} restore={true} />
    </Column>
  )
}

export default InstituteStaffsPage
